import { DefaultTableTypeAbstract } from "./gameTypes/defaultTableTypes/DefaultTableTypeAbstract";
import { DefaultTableTypeFast } from "./gameTypes/defaultTableTypes/DefaultTableTypeFast";
import { DefaultTableTypeMin50BB } from "./gameTypes/defaultTableTypes/DefaultTableTypeMin50BB";
import { DefaultTableTypeStandard } from "./gameTypes/defaultTableTypes/DefaultTableTypeStandard";
import { SitngoTypeAbstract } from "./gameTypes/sitngoTypes/SitngoTypeAbstract";
import { SitngoTypeStandard } from "./gameTypes/sitngoTypes/SitngoTypeStandard";
import { SitngoTypeStandardSpectator } from "./gameTypes/sitngoTypes/spectator/SitngoTypeStandardSpectator";
import { TournamentTypeFreezeoutSpectator } from "./gameTypes/tournamentTypes/spectator/TournamentTypeFreezeoutSpectator";
import { TournamentTypeRebuySpectator } from "./gameTypes/tournamentTypes/spectator/TournamentTypeRebuySpectator";
import { TournamentTypeShootoutSpectator } from "./gameTypes/tournamentTypes/spectator/TournamentTypeShootoutSpectator";
import { TournamentTypeAbstract } from "./gameTypes/tournamentTypes/TournamentTypeAbstract";
import { TournamentTypeFreezeout } from "./gameTypes/tournamentTypes/TournamentTypeFreezeout";
import { TournamentTypeRebuy } from "./gameTypes/tournamentTypes/TournamentTypeRebuy";
import { TournamentTypeShootout } from "./gameTypes/tournamentTypes/TournamentTypeShootout";

export class PokerGameTypes {
    // default table types
    public static DEFAULT_TABLE_TYPE_ABSTRACT: DefaultTableTypeAbstract;
    public static DEFAULT_TABLE_TYPE_STANDARD: DefaultTableTypeStandard;
    public static DEFAULT_TABLE_TYPE_FAST: DefaultTableTypeFast;
    public static DEFAULT_TABLE_TYPE_MIN50BB: DefaultTableTypeMin50BB;

    // tournament types
    public static TOURNAMENT_TYPE_ABSTRACT: TournamentTypeAbstract;
    public static TOURNAMENT_TYPE_SHOOTOUT: TournamentTypeShootout;
    public static TOURNAMENT_TYPE_SHOOTOUT_SPECTATOR: TournamentTypeShootoutSpectator;
    public static TOURNAMENT_TYPE_FREEZEOUT: TournamentTypeFreezeout;
    public static TOURNAMENT_TYPE_FREEZEOUT_SPECTATOR: TournamentTypeFreezeoutSpectator;
    public static TOURNAMENT_TYPE_REBUY: TournamentTypeRebuy;
    public static TOURNAMENT_TYPE_REBUY_SPECTATOR: TournamentTypeRebuySpectator;

    // sitngo types
    public static SITNGO_TYPE_ABSTRACT: SitngoTypeAbstract;
    public static SITNGO_TYPE_STANDARD: SitngoTypeStandard;
    public static SITNGO_TYPE_STANDARD_SPECTATOR: SitngoTypeStandardSpectator;

    public static __initialize_static_members() {
        PokerGameTypes.DEFAULT_TABLE_TYPE_ABSTRACT = new DefaultTableTypeAbstract();
        PokerGameTypes.DEFAULT_TABLE_TYPE_STANDARD = new DefaultTableTypeStandard();
        PokerGameTypes.DEFAULT_TABLE_TYPE_FAST = new DefaultTableTypeFast();
        PokerGameTypes.DEFAULT_TABLE_TYPE_MIN50BB = new DefaultTableTypeMin50BB();
        PokerGameTypes.TOURNAMENT_TYPE_ABSTRACT = new TournamentTypeAbstract();
        PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT = new TournamentTypeShootout();
        PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT_SPECTATOR = new TournamentTypeShootoutSpectator();
        PokerGameTypes.TOURNAMENT_TYPE_FREEZEOUT = new TournamentTypeFreezeout();
        PokerGameTypes.TOURNAMENT_TYPE_FREEZEOUT_SPECTATOR = new TournamentTypeFreezeoutSpectator();
        PokerGameTypes.TOURNAMENT_TYPE_REBUY = new TournamentTypeRebuy();
        PokerGameTypes.TOURNAMENT_TYPE_REBUY_SPECTATOR = new TournamentTypeRebuySpectator();
        PokerGameTypes.SITNGO_TYPE_ABSTRACT = new SitngoTypeAbstract();
        PokerGameTypes.SITNGO_TYPE_STANDARD = new SitngoTypeStandard();
        PokerGameTypes.SITNGO_TYPE_STANDARD_SPECTATOR = new SitngoTypeStandardSpectator();
    }
}
PokerGameTypes.__initialize_static_members();
